// src/pages/view/ReviewPage.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API_URL from "../../../config/apiConfig";
import { getRestaurantByMenuLink, submitReview } from "../../../api/reviews";

export default function ReviewPage() {
  const { menuLink } = useParams();
  const navigate = useNavigate();
  const [restaurant, setRestaurant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // فرم
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [comment, setComment] = useState("");
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    const fetchRestaurant = async () => {
      try {
        const restaurantData = await getRestaurantByMenuLink(menuLink);
        setRestaurant(restaurantData);
      } catch (err) {
        setError("مشکل در دریافت اطلاعات رستوران");
      } finally {
        setLoading(false);
      }
    };

    if (menuLink) fetchRestaurant();
    else {
      setError("لینک منو موجود نیست");
      setLoading(false);
    }
  }, [menuLink]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (rating < 1) {
      alert("لطفاً امتیاز بدهید");
      return;
    }
    if (!comment.trim()) {
      alert("نظر نمی‌تواند خالی باشد");
      return;
    }

    if (!restaurant?._id) {
      alert("مشکل در دریافت اطلاعات رستوران");
      return;
    }

    try {
      const res = await submitReview({
        restaurantId: restaurant._id,
        name,
        phone,
        comment,
        stars: rating,
      });

      if (res.status === 201 || res.status === 200) {
        setSuccessMessage("ممنون که نظرتان را ثبت کردید 🙏");
        setName("");
        setPhone("");
        setComment("");
        setRating(0);

        setTimeout(() => setSuccessMessage(""), 3000);
      }
    } catch (err) {
      console.log(err);
      alert("مشکل در ثبت نظر، دوباره تلاش کنید");
    }
  };

  if (loading) return <div className="text-center mt-20 text-gray-500">در حال بارگذاری...</div>;
  if (error) return <div className="text-red-500 mt-20 text-center">{error}</div>;
  if (!restaurant) return null;

  const profileImage = restaurant.restaurantSettings?.profileImage
    ? `${API_URL}/uploads/restaurants/${restaurant._id}/${restaurant.restaurantSettings.profileImage}`
    : "/images/default-profile.png";

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <header className="bg-white shadow-md p-4 flex items-center justify-between">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-gray-700 hover:text-green-600 font-medium"
        >
          ← بازگشت
        </button>
        <div className="flex items-center gap-3">
          <span className="font-semibold text-gray-800 text-lg">{restaurant.name}</span>
          <img
            src={profileImage}
            alt="logo"
            className="w-12 h-12 rounded-full object-cover shadow-sm border border-gray-200"
          />
        </div>
      </header>

      {/* Form */}
      <main className="flex-1 max-w-md mx-auto p-6">
        <form
          onSubmit={handleSubmit}
          className="space-y-5 bg-white p-6 rounded-xl border border-gray-100"
        >
          {successMessage && (
            <div className="bg-green-50 border border-green-200 p-4 rounded-lg text-green-700 font-medium shadow-sm text-center">
              {successMessage}
            </div>
          )}

          <h2 className="text-xl font-bold text-gray-800 mb-3">ثبت نظر شما</h2>

          <input
            type="text"
            placeholder="نام (اختیاری)"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary transition"
          />

          <input
            type="text"
            placeholder="شماره موبایل (اختیاری)"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary transition"
          />

          <textarea
            placeholder="نظر خود را بنویسید..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows={5}
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary transition resize-none"
          />

          {/* Rating */}
          <div className="flex items-center gap-2">
            {[1, 2, 3, 4, 5].map((star) => {
              const filled = star <= (hoverRating || rating);
              return (
                <span
                  key={star}
                  className={`cursor-pointer text-3xl transition-transform duration-150 ${filled
                    ? "text-yellow-400 drop-shadow-md"
                    : "text-gray-300 hover:text-yellow-300 transform hover:scale-110"
                    }`}
                  onClick={() => setRating(star)}
                  onMouseEnter={() => setHoverRating(star)}
                  onMouseLeave={() => setHoverRating(0)}
                >
                  ★
                </span>
              );
            })}
          </div>

          <button
            type="submit"
            className="w-full py-3 bg-primary text-white rounded-lg hover:bg-primary-dark transition font-semibold"
          >
            ارسال نظر
          </button>
        </form>
      </main>
    </div>
  );
}